import type { KaiFeedContext } from "@/services/kaiApi";
import { loadFeedFilters } from "@/features/feed/feedKaiFilters";

/**
 * Build the feed-scope snapshot Kai receives in `client_context.feed_context`
 * when the user is on the Feed page, or `undefined` on any other route.
 *
 * Reads the shared `twido:feed:filters` sessionStorage the `FeedContext` owns,
 * so Kai sees exactly the scope the user is currently viewing.
 */
export function buildKaiFeedContext(
  pathname: string,
): KaiFeedContext | undefined {
  if (pathname !== "/feed" && !pathname.startsWith("/feed/")) return undefined;
  const filters = loadFeedFilters();
  return {
    scope_dimension: filters.scopeDimension,
    scope_key: filters.scopeKey,
    time_horizon: filters.timeHorizon,
    severity: filters.severity,
    event_type: filters.eventType,
  };
}
